import React from 'react';
import HelpPageComponent from './help.component.jsx';

function Help() {
    return <HelpPageComponent />;
}

export default Help;
